<template>
  <div class="d-flex align-center">
    <div style="position:relative">
      <PractitionerAvatar
        :id="(practitioner.profilePicture || {}).id"
        size="70"
      ></PractitionerAvatar>
      <v-btn
        @click="() => $refs.inputRef.click()"
        absolute
        fab
        width="35"
        height="35"
        style="right: 0px; bottom: 0px"
        color="secondary"
      >
        <v-icon size="18">mdi-camera</v-icon>
      </v-btn>
    </div>
    <span class="subtitle-1 font-weight-bold secondary--text pl-4"
      >Foto de perfil</span
    >

    <input
      hidden
      type="file"
      ref="inputRef"
      accept="image/*"
      @change="updatePhoto"
    />

    <v-dialog v-model="dialogSuccess" max-width="500">
      <v-card>
        <v-card-title>Foto de perfil actualizada exitosamente</v-card-title>
        <sweetalert-icon icon="success" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PractitionerAvatar from "./PractitionerAvatar";
export default {
  props: ["practitioner"],
  components: { PractitionerAvatar },
  data: () => ({ fileInputValue: null, dialogSuccess: false }),
  methods: {
    async updatePhoto() {
      try {
        let files = this.$refs.inputRef.files || [];
        this.$refs.inputRef.files = null;

        for (let file of files) {
          let formData = new FormData();
          formData.append("fileupload", file);
          let { data: created } = await this.$http.post("archive", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          });

          this.practitioner.profilePicture = created;

          await this.$http.patch("practitioner/" + this.practitioner.id, {
            profilePicture: created.id
          });

          this.dialogSuccess = true;
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err);
      }
    }
  }
};
</script>

<style></style>
